import React from "react";
import styles from "./styles";
import {
  withStyles,
  CardContent,
  Card,
  CardHeader,
  withTheme,
  IconButton,
} from "@material-ui/core";
import { compose } from "recompose";
import ReturnToTerminalIcon from "../../../../IBPlanning/Common/ReturnToTerminalIcon";
import { ALL_DRIVER_STATUS } from "../../constants";
import EndTripIcon from "../../../../../../layout/icons/EndTripIcon";
import Tooltip from "../../../../../common/StyledToolTip";
import EndTripConfirmation from "../../EndTrip/EndTripConfirmation";
import { checkIsEndTripEnabled, formatArriveAtTerminalTime } from "../../../utils/utils";
import { withAppConfig } from "../../../../../../appConfigContext";

class TerminalCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEndTripModal: false,
    };
  }

  hideEndTripModal = () => {
    this.setState({
      showEndTripModal: false,
    });
  };

  onShowEndTrip = () => {
    this.setState({
      selectedDispatchRoute: {
        driverId: this.props.routeData.driverId,
        routeId: this.props.routeData.routeId,
      },
      showEndTripModal: true,
    });
  };

  renderEndTripIcon = () => {
    const {
      classes,
      theme,
      routeData,
      currentDriverRoutes,
      configJSON: { startEndTripWorkflow }
    } = this.props;
    const enableIcon = checkIsEndTripEnabled({
      startEndTripWorkflow,
      routeStatus: routeData?.routeStatus,
      driverRoutes: currentDriverRoutes
    });
    return (
      <Tooltip title={"End Trip"}>
        <IconButton
          aria-label="End Trip"
          component="div"
          disabled={!enableIcon}
          className={enableIcon ? classes.enableIcon : classes.disableIcon}
          onClick={enableIcon? this.onShowEndTrip : null}
        >
          <EndTripIcon color={enableIcon ? theme.error : theme.iconColor} />
        </IconButton>
      </Tooltip>
    );
  };
  render() {
    const { classes, userData, routeData } = this.props;
    return (
      <Card className={classes.card}>
        <CardHeader
          classes={{
            title: classes.title,
            subheader: classes.subheader,
            root: classes.headerRoot,
            avatar: classes.avatar
          }}
          action={this.renderEndTripIcon()}
          avatar={<ReturnToTerminalIcon width={42} height={42} />}
          title={`${userData.userProfile.terminal.code}: RETURN TO TERMINAL`}
          subheader={""}
        />
        <CardContent className={classes.noPadding}>
          <div className={classes.statusWrapper}>
            <span className={classes.statusTime}>
              {routeData.routeStatus === ALL_DRIVER_STATUS.ArrivedAtTerminal
                ? "Arrived at terminal"
                : "ETA"}
            </span>
            <span className={classes.statusTime}>
              {formatArriveAtTerminalTime(routeData.arriveAtTerminalTime)}
            </span>
          </div>
        </CardContent>
        {this.state.showEndTripModal ? (
          <EndTripConfirmation
            onCancel={this.hideEndTripModal}
            userData={userData}
            driverInfo={routeData}
          />
        ) : null}
      </Card>
    );
  }
}

export default compose(withStyles(styles), withTheme(), withAppConfig)(TerminalCard);
